import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { luckySpinAPI } from '../../../services/api';

export const fetchRewards = createAsyncThunk(
  'rewards/fetchRewards',
  async (rewardSet = 'base', { rejectWithValue }) => {
    try {
      
      const response = await luckySpinAPI.getRewards(rewardSet);
      
      return response;
    } catch (error) {
      console.error('Error fetching rewards:', error);
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  rewards: [],
  isLoading: false,
  error: null,
  lastFetch: null,
};

const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setRewards: (state, action) => {
      state.rewards = action.payload;
      state.lastFetch = new Date().toISOString();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRewards.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRewards.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rewards = action.payload;
        state.lastFetch = new Date().toISOString();
      })
      .addCase(fetchRewards.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, setRewards } = rewardsSlice.actions;
export default rewardsSlice.reducer;
